<template>
  <div class="table-responsive">
    <table :id="table_id" class="table table-striped table-bordered">
      <thead>
        <tr>
          <th style="width: 25% !important">Title</th>
          <th style="width: 35% !important">Description</th>
          <th style="width: 10% !important">Award Points</th>
          <th style="width: 10% !important">Start Date</th>
          <th style="width: 10% !important">End Date</th>
          <th style="width: 10% !important">Time</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(notification, index) in massNotifications" :key="index">
          <td>
            <router-link :to="navigateTo(notification.id)">
              {{ notification.title }}
            </router-link>
          </td>
          <td>{{ notification.description }}</td>
          <td>{{ notification.type == 3 ? notification.type_text : `${notification.type_text} ${notification.type == 2 ? ' x' : ' - '} ${notification.award_points}` }}</td>
          <td>{{ notification.start_date_formatted }}</td>
          <td>{{ notification.end_date_formatted }}</td>
          <td>{{ notification.time_formatted }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'mass-notification-table',

  props: {
    massNotifications: {
      type: Array,
      required: true
    },
    table_id: {
      type: String,
      default: 'mass-notification-tbl'
    }
  },

  data() {
    return {

    }
  },

  methods: {
    navigateTo(id) {
      return `/marketing/mass-notification/${id}`;
    },
  },

  mounted() {
  }

}
</script>
